$(function() {

    const $section = $('#centre-map');

    if ($section.length) {

        $section.find('.map-wrapper-inner').each(function () {
            const $image = $(this);

            if ($image.length) {
                $image.panzoom({
                    $zoomIn: $('.map-controls .zoom-in'),
                    $zoomOut: $('.map-controls .zoom-out'),
                    $zoomRange: $('.map-controls .zoom-range'),
                    $reset: $('.map-controls .reset'),
                    startTransform: 'scale(1)',
                    minScale: 1,
                    cursor: "move",
                    contain: 'invert'
                });

                const mc = new Hammer.Manager($image.get(0));
                mc.add(new Hammer.Tap({event: 'doubletap', taps: 2}));
                mc.on('doubletap', function (ev) {
                    const zoom = parseFloat($image.panzoom('getMatrix')[0]) + 1;
                    $image.panzoom("zoom", zoom, {
                        animate: true,
                        focal: {
                            clientX: ev.center.x,
                            clientY: ev.center.y
                        }
                    });
                });
            }
        });

    }

});
